import { KYMW1317Model } from '../kymw1317.model';
import { ApprovalItemListModel } from '../vo/kymw1317-approval-item-list.model';
import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 企画連絡承認画面　承認項目一覧を取得するサービス
 *
 * @export GetApprovalItemListService
 * @class GetApprovalItemListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetApprovalItemListService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1317Model}
   * @memberof GetApprovalItemListService
   */
  private model: KYMW1317Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {ApprovalItemListModel}
   * @memberof GetApprovalItemListService
   */
  private vo: ApprovalItemListModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetApprovalItemListService
   */
  private successFunc: Function;

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetApprovalItemListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        PCode: this.vo.pCode,
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetApprovalItemListService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW1317Model>model;
    this.vo = <ApprovalItemListModel>vo;
    this.successFunc = successFunc;
    this.send('getApprovalItemList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetApprovalItemListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }

}
